import { render, staticRenderFns } from "./CellRendererDownload.vue?vue&type=template&id=28c58df4&"
import script from "./CellRendererDownload.vue?vue&type=script&lang=js&"
export * from "./CellRendererDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports